import { Badge, Grid2, Typography } from '@mui/material'
import Container from '../../../components/Container'
import { useCallback, useEffect, useRef, useState } from 'react'
import { IOrder, IOrderSocketResponse } from 'sierra'
import api from '../../../utils/axios'
import OrderCard from '../../../components/Cards/OrderCard'
import OrderCardSkeleton from '../../../components/Skeletons/OrderCardSkeleton'
import { Outlet, useLocation } from 'react-router-dom'
import DashboardOrderChat from './DashboardOrderChat'
import socket from '../../../utils/socket'
import { useApp } from '../../../contexts/AppContext'

const DashboardOrders = () => {
    const location = useLocation()
    const { translate } = useApp()

    const [orders, setOrders] = useState<Required<IOrder>[]>()
    const [openOrderChat, setOpenOrderChat] = useState<boolean>(false)

    const ordersRef = useRef(orders);

    const fetchOrders = () => {
        api.get('/orders', { params: { exclude_fields: 'service_form,branch' } }).then(({ data }) => setOrders(data)).catch(console.error)
    }

    const handleOrdersListener = useCallback((data: IOrderSocketResponse[]) => {
        if (!ordersRef.current) return
        const changedOrderIds = data.map(order => order.order_id);
        const shouldFetch = ordersRef.current.some(order => changedOrderIds.includes(order.order_id));
        if (shouldFetch) {
            fetchOrders();
        }
    }, [])

    useEffect(() => {
        ordersRef.current = orders; // Always update ref when orders change
    }, [orders]);

    useEffect(() => {
        fetchOrders()
        socket.on("orders_changed", handleOrdersListener);
        return () => {
            socket.off("orders_changed", handleOrdersListener);
        }
    }, [])

    useEffect(() => console.log(orders), [orders])

    return (
        <Grid2 container size={'grow'} spacing={location.pathname.split('/')[3] ? 2 : 0} sx={{ transition: { xs: 'none', lg: location.pathname.split('/')[3] ? 'all 0.8s cubic-bezier(0, 0.5, 0.2, 1)' : 'all 0.5s cubic-bezier(0.6, 0, 0.8, 0.4)' } }}>

            <Grid2 container display={{ xs: location.pathname.split('/')[3] ? 'none' : 'flex', lg: 'flex' }} size={{ xs: location.pathname.split('/')[3] ? 0 : 'grow', lg: 'grow' }} flexDirection={'column'} spacing={2}>

                <Container container size={'auto'} padding={2} justifyContent={'space-between'}>
                    <Grid2>
                        <Typography variant='h4' fontWeight={'bold'} color='primary'>
                            {translate("Orders")}
                        </Typography>
                    </Grid2>
                </Container>

                <Container container padding={2} flexDirection={'column'}>
                    <Grid2 container padding={2} sx={{ overflowX: 'hidden', overflowY: 'auto' }} spacing={2}>
                        {
                            !orders ? Array.from({ length: 3 }).map((a, i) => <OrderCardSkeleton key={i} hideButtons />) : orders.length === 0 ? <Grid2><Typography>No Orders to show</Typography></Grid2> :
                                orders
                                    // .concat(orders)
                                    // .concat(orders)
                                    // .concat(orders)
                                    // .concat(orders)
                                    // .concat(orders)
                                    .map((o, i) =>
                                        <OrderCard key={i} order={o} />
                                    )
                        }
                    </Grid2>
                    <Grid2 size={'grow'} />
                </Container>
            </Grid2>

            <Grid2 container size={location.pathname.split('/')[3] ? 'grow' : -1} sx={{ transition: { xs: 'none', lg: 'all 0.5s ease' } }} flexGrow={location.pathname.split('/')[3] ? 2 : 0} flexDirection={'column'} gap={openOrderChat ? 2 : 0} >
                <Container size={'grow'} height={'100%'} flexGrow={1.5}>
                    <Outlet context={{ setOpenOrderChat }} />
                </Container>
                <Container size={openOrderChat ? 'grow' : 0} sx={{ transition: 'all 0.5s ease' }}>
                    {openOrderChat && location.pathname.split('/')[3] && <DashboardOrderChat setOpenOrderChat={setOpenOrderChat} />}
                </Container>
            </Grid2>

        </Grid2>
    )
}

export default DashboardOrders